const loadExternalScript = (id, src) => {
  if (typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const initGoogleAnalytics = () => {
  if (typeof window === 'undefined' || window.__lechaGaInitialized) {
    return;
  }

  window.__lechaGaInitialized = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  loadExternalScript('lecha-gtag', 'https://www.googletagmanager.com/gtag/js?id=G-3LQ1SPBJC2');
  window.gtag('js', new Date());
  window.gtag('config', 'G-3LQ1SPBJC2');
  window.gtag('config', 'AW-17184221193');
};

const initMetaPixel = () => {
  if (typeof window === 'undefined' || window.__lechaMetaInitialized) {
    return;
  }

  window.__lechaMetaInitialized = true;

  if (!window.fbq) {
    const fbq = function fbqShim() {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
  }

  loadExternalScript('lecha-meta-pixel', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', '1844134569791495');
  window.fbq('track', 'PageView');
};

const initTikTokPixel = () => {
  if (typeof window === 'undefined' || window.__lechaTikTokInitialized) {
    return;
  }

  window.__lechaTikTokInitialized = true;

  const analyticsObject = 'ttq';
  const ttq = window[analyticsObject] = window[analyticsObject] || [];

  if (!ttq.methods) {
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
      'holdConsent',
      'revokeConsent',
      'grantConsent'
    ];

    ttq.setAndDefer = function setAndDefer(target, method) {
      target[method] = function deferredMethod() {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };

    ttq.methods.forEach((method) => ttq.setAndDefer(ttq, method));
    ttq.instance = function instance(id) {
      const queue = ttq._i[id] || [];
      ttq.methods.forEach((method) => ttq.setAndDefer(queue, method));
      return queue;
    };
    ttq.load = function load(pixelId, options) {
      const src = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[pixelId] = [];
      ttq._i[pixelId]._u = src;
      ttq._t = ttq._t || {};
      ttq._t[pixelId] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[pixelId] = options || {};
      loadExternalScript('lecha-tiktok-pixel', `${src}?sdkid=${pixelId}&lib=${analyticsObject}`);
    };
  }

  ttq.load('D4NFENJC77UAP3H8UEI0');
  ttq.page();
};

export const loadTrackingScripts = () => {
  initGoogleAnalytics();
  initMetaPixel();
  initTikTokPixel();
};
